// extracted by mini-css-extract-plugin
module.exports = {"container":"Question_container__1xrBP","q":"Question_q__yLjQS","a":"Question_a__20sNI"};